import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  LayoutDashboard, Users, FolderOpen, UserPlus, LogOut,
  Menu, X, Bell, Settings, Zap, TrendingUp
} from 'lucide-react';

const AdminLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const { user, logout } = useAuth();

  const menuItems = [
    { path: '/admin', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/admin/students', icon: Users, label: 'Students' },
    { path: '/admin/projects', icon: FolderOpen, label: 'Projects' },
    { path: '/admin/revenue', icon: TrendingUp, label: 'Revenue' },
    { path: '/admin/leads', icon: UserPlus, label: 'Leads' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="flex h-screen">
        <div className={`fixed inset-y-0 left-0 z-50 w-64 bg-gradient-to-b from-primary-800 to-primary-900 transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0`}>
          <div className="flex items-center justify-between h-16 px-6 bg-primary-900">
            <div className="flex items-center space-x-2">
              <Zap className="w-8 h-8 text-accent-400" />
              <span className="text-xl font-bold text-white">CodeToday</span>
            </div>
            <button
              onClick={() => setSidebarOpen(false)}
              className="lg:hidden text-white hover:text-gray-300"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          <nav className="mt-8">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center px-6 py-3 text-white transition-colors duration-200 ${
                  isActive(item.path)
                    ? 'bg-primary-700 border-l-4 border-accent-400'
                    : 'hover:bg-primary-700'
                }`}
              >
                <item.icon className="w-5 h-5 mr-3" />
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="absolute bottom-0 w-full p-6">
            <div className="bg-primary-700 rounded-lg p-4">
              <p className="text-white text-sm mb-2">Logged in as:</p>
              <p className="text-white font-semibold">{user?.name}</p>
              <p className="text-gray-300 text-xs">{user?.email}</p>
              <button
                onClick={logout}
                className="mt-3 flex items-center text-red-300 hover:text-red-200 text-sm"
              >
                <LogOut className="w-4 h-4 mr-2" />
                Logout
              </button>
            </div>
          </div>
        </div>

        <div className="flex-1 flex flex-col overflow-hidden">
          <header className="bg-white shadow-sm">
            <div className="flex items-center justify-between px-6 py-4">
              <button
                onClick={() => setSidebarOpen(true)}
                className="lg:hidden text-gray-600 hover:text-gray-900"
              >
                <Menu className="w-6 h-6" />
              </button>

              <h1 className="text-2xl font-semibold text-gray-800">
                {menuItems.find(item => isActive(item.path))?.label || 'Admin Panel'}
              </h1>

              <div className="flex items-center space-x-4">
                <button className="relative text-gray-600 hover:text-gray-900">
                  <Bell className="w-6 h-6" />
                  <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full"></span>
                </button>
                <button className="text-gray-600 hover:text-gray-900">
                  <Settings className="w-6 h-6" />
                </button>
              </div>
            </div>
          </header>

          <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50">
            <div className="container mx-auto px-6 py-8">
              {children}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;